module.exports = __webpack_public_path__ + "media/DING_DONG_DING.f44d0f60.mp3";